export const CYCLE_COUNT_ADJUSTMENT_VALUE = 'CYCLE_COUNT_ADJUSTMENT';
export const CYCLE_COUNT_ADJUSTMENT_LABEL = 'Cycle Count Adjustment';
export const CYCLE_COUNT_ADJUSTMENT_DESCRIPTION =
  'New/good parts found in a location, during cycle count activities, with no discernable source.';

export const RECOVERED_GEAR_VALUE = 'RECOVERED_GEAR';
export const RECOVERED_GEAR_LABEL = 'Recovered Gear';
export const RECOVERED_GEAR_DESCRIPTION =
  'New/good parts found at the site OR good parts removed from racks with no discernable source.';

export const REHARVESTED_GEAR_VALUE = 'REHARVESTED_GEAR';
export const REHARVESTED_GEAR_LABEL = 'Reharvested Gear';
export const REHARVESTED_GEAR_DESCRIPTION = 'Broken parts removed from racks with no discernable source.';
export const REHARVESTED_GEAR_DESCRIPTION_NOTE =
  'These parts are expected to be changed from a Spare to a Broken state within 1 hour of ingestion, before being destroyed/shipped to Failure Analysis Labs/ Winston Wolfe.';
